exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EventsEmbed-25b85e4c{background-color:#fff;height:100%;overflow-y:scroll}.header-042d00f8{border-bottom:1px solid #E0E0E0;display:flex;justify-content:space-between;align-items:center;padding:15px}.left-818b28ec{flex:0 1 auto}.logo-0b47f54b{flex:0 1 auto;height:28px}.title-e872cde8{font-size:18px;line-height:22px}.title-e872cde8 a{text-decoration:none}.description-6a35b2d9{font-size:14px;color:#424242}\n", ""]);

// Exports
exports.locals = {
	"EventsEmbed": "EventsEmbed-25b85e4c",
	"header": "header-042d00f8",
	"left": "left-818b28ec",
	"logo": "logo-0b47f54b",
	"title": "title-e872cde8",
	"description": "description-6a35b2d9"
};